import info from "./infoActions"


export default {info}